// PistolDebugUI.js - Debug interface for testing pistol skill system

class PistolDebugUI {
  constructor() {
    this.visible = false;
    this.container = null;
    this.createUI();
    
    // Register keyboard shortcut (Shift+P)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'P' && e.shiftKey) {
        this.toggleVisibility();
      }
    });
    
    // Update interval
    this.updateInterval = setInterval(() => this.updateStats(), 500);
    
    console.log("PistolDebugUI initialized - Press Shift+P to toggle");
  }
  
  createUI() {
    // Create container
    this.container = document.createElement('div');
    this.container.id = 'pistol-debug-ui';
    this.container.style.cssText = `
      position: fixed;
      top: 10px;
      right: 10px;
      width: 250px;
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 10px;
      border-radius: 5px;
      font-family: monospace;
      font-size: 12px;
      z-index: 1000;
      display: none;
    `;
    
    // Create header
    const header = document.createElement('div');
    header.textContent = "🔫 Pistol Debug";
    header.style.cssText = `
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 10px;
      text-align: center;
      background-color: #333;
      padding: 5px;
    `;
    this.container.appendChild(header);
    
    // Stats section
    this.statsContainer = document.createElement('div');
    this.statsContainer.style.marginBottom = '15px';
    this.container.appendChild(this.statsContainer);
    
    // Controls section
    const controls = document.createElement('div');
    controls.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 5px;
    `;
    
    // Add XP button
    const addXpButton = document.createElement('button');
    addXpButton.textContent = "Add 10 XP";
    addXpButton.onclick = () => {
      if (window.pistolSkill) {
        window.pistolSkill.debugAddXP(10);
        this.updateStats();
      }
    };
    
    // Level Up button
    const levelUpButton = document.createElement('button');
    levelUpButton.textContent = "Force Level Up";
    levelUpButton.onclick = () => {
      if (window.pistolSkill) {
        window.pistolSkill.debugLevelUp();
        this.updateStats();
      }
    };
    
    // Spawn Zombie button
    const spawnZombieButton = document.createElement('button');
    spawnZombieButton.textContent = "Spawn Test Zombie";
    spawnZombieButton.onclick = () => {
      if (window.zombieManager && window.playerMesh) {
        window.zombieManager.spawnZombie(window.playerMesh);
      }
    };
    
    // Add buttons to controls
    controls.appendChild(addXpButton);
    controls.appendChild(levelUpButton);
    controls.appendChild(spawnZombieButton);
    this.container.appendChild(controls);
    
    // Add to document
    document.body.appendChild(this.container);
  }
  
  toggleVisibility() {
    this.visible = !this.visible;
    this.container.style.display = this.visible ? 'block' : 'none';
    
    if (this.visible) {
      this.updateStats();
    }
  }
  
  updateStats() {
    if (!this.visible || !window.pistolSkill) return;
    
    const stats = window.pistolSkill.getStats();
    this.statsContainer.innerHTML = `
      <div>Level: ${stats.level}</div>
      <div>XP: ${stats.xp}/${stats.xpToNextLevel}</div>
      <div>Damage: ${stats.damage}</div>
      <div>Reload Time: ${stats.reloadTime.toFixed(0)}ms</div>
      <div>Magazine: ${stats.magazineSize}</div>
      <div>Zombie Kills XP: ${stats.xpSources.zombieKills}</div>
      <div>Debug XP: ${stats.xpSources.debugXp}</div>
    `;
  }
}

// Create instance when module loads
const pistolDebugUI = new PistolDebugUI();
export default pistolDebugUI; 